import { schema } from 'normalizr';
import { transcriptSchema } from '../transcript-service/service';

export const videoSchema = new schema.Entity(
  'videos',
  {
    transcript: transcriptSchema,
  },
  {
    idAttribute: 'id',
    processStrategy: value => ({
      ...value,
      transcript: {
        ...value.transcript,
        id: value.id,
      },
    }),
  },
);

export const textSchema = new schema.Entity(
  'textBlobs',
  {},
  {
    idAttribute: 'textBlobId',
  },
);

export const mediaSegmentDataSchema = new schema.Entity(
  'mediaSegmentData',
  {},
  {
    idAttribute: 'uuid',
  },
);

export const videoLayoutTimelineSchema = new schema.Entity(
  'videoLayoutTimeline',
  {},
  {
    idAttribute: 'uuid',
  },
);

export const entireVideosSchema = new schema.Entity('entireVideos', {});

export const entireVideoInstancesSchema = new schema.Entity(
  'entireVideoInstances',
  {
    entireVideo: entireVideosSchema,
  },
  {
    // In some cases, the backend will try to determine if the uploaded file exists,
    // and while it's doing so, the entireVideo key in the instance object will be
    // defined but will have the id set to null.  The processStrategy here omits the
    // entireVideo object if the id is null so that we don't wind up with an id
    // of null in the entireVideos redux entities
    processStrategy: (instance: { entireVideo?: { id?: number } }) => {
      if (!instance?.entireVideo?.id) {
        const { entireVideo, ...rest } = instance;

        return rest;
      }

      return { ...instance };
    },
  },
);
